import { InjectionToken } from '@angular/core';
import { App } from '../enums/app.enum';

export const APP_NAME = new InjectionToken<App>('APP_NAME');
